import { apiFetch } from "./client";

export interface OnboardingData {
  id: string;
  companyId: string;
  status: "pending" | "in_progress" | "researching" | "complete" | "failed" | "not_started";
  currentStep: number;
  websiteUrl: string | null;
  businessDescription: string | null;
  brandGuidelinesContent: string | null;
  departments: string[] | null;
  itSystems: string[] | null;
  enrichedProfile: string | null;
  researchError: string | null;
  completedAt: string | null;
}

export const onboardingApi = {
  getStatus: (companyId: string) =>
    apiFetch<OnboardingData>(`/companies/${companyId}/onboarding`),

  saveStep: (companyId: string, stepNumber: number, data: Record<string, unknown>) =>
    apiFetch<OnboardingData>(`/companies/${companyId}/onboarding/step/${stepNumber}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),

  uploadGuidelines: (companyId: string, content: string) =>
    apiFetch<{ success: boolean }>(`/companies/${companyId}/onboarding/upload-guidelines`, {
      method: "POST",
      body: JSON.stringify({ content }),
    }),

  triggerResearch: (companyId: string) =>
    apiFetch<{ status: string }>(`/companies/${companyId}/onboarding/research`, {
      method: "POST",
    }),

  getResearchStatus: (companyId: string) =>
    apiFetch<{ status: string; enrichedProfile?: string; researchError?: string }>(
      `/companies/${companyId}/onboarding/research/status`
    ),

  complete: (companyId: string) =>
    apiFetch<{ success: boolean }>(`/companies/${companyId}/onboarding/complete`, {
      method: "POST",
    }),
};
